import {
  TabsContent,
  TabsList,
  TabsRoot,
  TabsTrigger,
  TabsTriggerLink,
} from '../../molecules/Tabs/Tabs';
import { MyAssetsList } from '../MyAssetsList/MyAssetsList';
import { MyAssetsTabsProps } from './MyAssetsTabs.types';

export const MyAssetsTabs = ({
  assetUrl,
  upmPackages,
  microcopy,
  className = '',
  isManageSeatEnabled,
  ...actions
}: MyAssetsTabsProps) => {
  return (
    <TabsRoot defaultValue="upmPackages" className={className}>
      <TabsList>
        <TabsTriggerLink value="assets" url={assetUrl}>
          {microcopy.assets}
        </TabsTriggerLink>
        <TabsTrigger value="upmPackages">{microcopy.upmPackages}</TabsTrigger>
      </TabsList>
      <TabsContent value="upmPackages" tabIndex={-1} className="lg:pt-9">
        <MyAssetsList
          {...upmPackages}
          {...actions}
          isManageSeatEnabled={isManageSeatEnabled}
          microcopy={microcopy.list}
        />
      </TabsContent>
    </TabsRoot>
  );
};
